import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChartSyncService {
  /**
   * Is needed to synchronize the scroll in charts on one page.
   * Is called when one chart is scrolled
   * extremes: scroll position
   */
  private syncSubject = new Subject<ChartExtremes>();

  get chartSync$(): Observable<ChartExtremes> {
    return this.syncSubject.asObservable();
  }

  syncCharts(extremes: ChartExtremes): void {
    this.syncSubject.next(extremes);
  }
}

export interface ChartExtremes {
  min: number;
  max: number;
}
